import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import authClient from '../../../api/auth';

const useSendVerificationEmailMutation = (
  options?: UseMutationOptions<void, Error, void>,
) => {
  return useMutation({
    mutationFn: () => authClient.sendVerificationEmail(),
    ...options,
  });
};

export default useSendVerificationEmailMutation;
